import * as URLS from '../../../urls'

export const getErrors = (getLooksMissingProducts, getLooksMissingWearerAssignment) => ({
  emptyHtos: getLooksMissingProducts.filter((look) => look.hto),
  emptyLooks: getLooksMissingProducts.filter((look) => !look.hto),
  unassignedLooks: getLooksMissingWearerAssignment,
})

export const getLinkProps = (userNeedsSizes, userHasSizes) => {
  if (!userNeedsSizes) {
    // the user is renting for other people, so they can go straight to checkout
    return {
      children: 'Proceed to Checkout',
      to: URLS.CHECKOUT,
    }
  }
  if (!userHasSizes) {
    // we don't have sizes for this user
    return {
      children: 'Continue to Find My Sizes',
      to: URLS.FIT_INTRO,
    }
  }
  // we already have sizes for this user, go to review
  return {
    children: 'Continue to Review My Sizes',
    to: URLS.FIT_SIZES,
  }
}

export const scrollToFirstLookError = (allLooks, errors) => {
  const {emptyHtos, emptyLooks, noHtoDate, unassignedLooks} = errors
  const dashboard = document.getElementsByClassName('dashboard-content')[0]
  // if there is no selected hto date, scroll up
  if (noHtoDate) {
    const htoLookId = allLooks.find((look) => look.hto).id
    dashboard.scrollTop = document.getElementsByClassName(htoLookId)[0].offsetTop - 20
  } else if (emptyHtos.length || emptyLooks.length || unassignedLooks.length) {
    // find the look with an error and scroll to it
    allLooks.forEach((look) => {
      if (
        emptyHtos.some((hto) => hto.id === look.id) ||
        emptyLooks.some((emptyLook) => emptyLook.id === look.id) ||
        unassignedLooks.some((unassignedLook) => unassignedLook.id === look.id)
      ) {
        dashboard.scrollTop = document.getElementsByClassName(look.id)[0].offsetTop - 20
      }
      return look
    })
  }
}
